import React from 'react'
import * as styles from './index.module.scss'

import ArrowLeft from './svg/arrowLeft'
import ArrowRight from './svg/arrowRight'
import Chat from './svg/chat'
import Check from './svg/check'
import ChevronDown from './svg/chevronDown'
import ChevronLeft from './svg/chevronLeft'
import ChevronRight from './svg/chevronRight'
import ChevronUp from './svg/chevronUp'
import Cog from './svg/cog'
import Copy from './svg/copy'
import Cross from './svg/cross'
import CrossCircle from './svg/crossCircle'
import CrossLarge from './svg/crossLarge'
import CrossLight from './svg/crossLight'
import DotsVertical from './svg/dotsVertical'
import Download from './svg/download'
import DropdownArrow from './svg/dropdownArrow'
import EmojiSmile from './svg/emojiSmile'
import ExternalLink from './svg/externalLink'
import Filter from './svg/filter'
import Form from './svg/form'
import Inbox from './svg/inbox'
import Loading from './svg/loading'
import Logout from './svg/logout'
import Magnifier from './svg/magnifier'
import MailOpen from './svg/mailOpen'
import MessageReadCheck from './svg/messageReadCheck'
import MessageSentCheck from './svg/messageSentCheck'
import Office from './svg/office'
import PaperClip from './svg/paperClip'
import Collapse from './svg/collapse'
import Expand from './svg/expand'
import Pencil from './svg/pencil'
import People3 from './svg/people3'
import Plus from './svg/plus'
import Refresh from './svg/refresh'
import Sparkle from './svg/sparkle'
import Stack from './svg/stack'
import Star from './svg/star'
import StarOutline from './svg/starOutline'
import Swatch from './svg/swatch'
import Trash from './svg/trash'
import Person from './svg/person'
import Upload from './svg/upload'
import Replies from './svg/replies'
import Facebook from './svg/facebook'
import Envelope from './svg/envelope'
import Lifering from './svg/lifering'
import IconOneCol from './svg/columns/oneCol'
import IconTwoCol from './svg/columns/twoCol'
import IconThreeCol from './svg/columns/threeCol'
import IconFourCol from './svg/columns/fourCol'
import IconFiveCol from './svg/columns/fiveCol'
import IconOneTwoCol from './svg/columns/oneTwoCol'
import IconTwoOneCol from './svg/columns/twoOneCol'
import IconParagraph from './svg/editor/paragraph'
import IconImage from './svg/editor/image'
import IconButton from './svg/editor/button'
import IconDivider from './svg/editor/divider'
import IconSpacer from './svg/editor/spacer'
import IconHeading from './svg/editor/heading'
import IconYoutube from './svg/editor/youtube'
import IconSocialLinks from './svg/editor/socialLinks'
import IconCountdown from './svg/editor/countdown'
import IconHtml from './svg/editor/html'
import IconSurvey from './svg/editor/survey'
import IconRss from './svg/editor/rss'
import IconLpNavMenu from './svg/editor/lpNavMenu'
import IconContainerStyleBare from './svg/containerStyle/bare'
import IconContainerStyleContained from './svg/containerStyle/contained'
import IconContainerStyleCard from './svg/containerStyle/card'

export default function Icon({ name, ...rest }) {
    const iconProps = {
        className: styles.root,
        ...rest
    }

    switch (name) {
        case 'arrow-left':
            return <ArrowLeft {...iconProps} />

        case 'arrow-right':
            return <ArrowRight {...iconProps} />

        case 'chat':
            return <Chat {...iconProps} />

        case 'check':
            return <Check {...iconProps} />

        case 'chevron-down':
            return <ChevronDown {...iconProps} />

        case 'chevron-left':
            return <ChevronLeft {...iconProps} />

        case 'chevron-right':
            return <ChevronRight {...iconProps} />

        case 'chevron-up':
            return <ChevronUp {...iconProps} />

        case 'cog':
            return <Cog {...iconProps} />

        case 'copy':
            return <Copy {...iconProps} />

        case 'cross':
            return <Cross {...iconProps} />

        case 'cross-circle':
            return <CrossCircle {...iconProps} />

        case 'cross-large':
            return <CrossLarge {...iconProps} />

        case 'cross-light':
            return <CrossLight {...iconProps} />

        case 'dots-vertical':
            return <DotsVertical {...iconProps} />

        case 'download':
            return <Download {...iconProps} />

        case 'dropdown-arrow':
            return <DropdownArrow {...iconProps} />

        case 'emoji-smile':
            return <EmojiSmile {...iconProps} />

        case 'external-link':
            return <ExternalLink {...iconProps} />

        case 'filter':
            return <Filter {...iconProps} />

        case 'inbox':
            return <Inbox {...iconProps} />

        case 'logout':
            return <Logout {...iconProps} />

        case 'loading':
            return <Loading {...iconProps} />

        case 'magnifier':
            return <Magnifier {...iconProps} />

        case 'mail-open':
            return <MailOpen {...iconProps} />

        case 'message-read-check':
            return <MessageReadCheck {...iconProps} />

        case 'message-sent-check':
            return <MessageSentCheck {...iconProps} />

        case 'office':
            return <Office {...iconProps} />

        case 'paper-clip':
            return <PaperClip {...iconProps} />
        case 'collapse':
            return <Collapse {...iconProps} />
        case 'expand':
            return <Expand {...iconProps} />

        case 'pencil':
            return <Pencil {...iconProps} />

        case 'people3':
            return <People3 {...iconProps} />

        case 'plus':
            return <Plus {...iconProps} />

        case 'refresh':
            return <Refresh {...iconProps} />

        case 'sparkle':
            return <Sparkle {...iconProps} />

        case 'stack':
            return <Stack {...iconProps} />

        case 'star':
            return <Star {...iconProps} />

        case 'star-outline':
            return <StarOutline {...iconProps} />

        case 'swatch':
            return <Swatch {...iconProps} />

        case 'trash':
            return <Trash {...iconProps} />

        case 'person':
            return <Person {...iconProps} />
        case 'upload':
            return <Upload {...iconProps} />
        case 'replies':
            return <Replies {...iconProps} />
        case 'facebook':
            return <Facebook {...iconProps} />
        case 'envelope':
            return <Envelope {...iconProps} />
        case 'lifering':
            return <Lifering {...iconProps} />
        case 'oneCol':
            return <IconOneCol {...iconProps} />
        case 'twoCol':
            return <IconTwoCol {...iconProps} />
        case 'threeCol':
            return <IconThreeCol {...iconProps} />
        case 'fourCol':
            return <IconFourCol {...iconProps} />
        case 'fiveCol':
            return <IconFiveCol {...iconProps} />
        case 'oneTwoCol':
            return <IconOneTwoCol {...iconProps} />
        case 'twoOneCol':
            return <IconTwoOneCol {...iconProps} />
        case 'containerStyleBare':
            return <IconContainerStyleBare {...iconProps} />
        case 'containerStyleContained':
            return <IconContainerStyleContained {...iconProps} />
        case 'containerStyleCard':
            return <IconContainerStyleCard {...iconProps} />
        case 'paragraph':
            return <IconParagraph {...iconProps} />
        case 'image':
            return <IconImage {...iconProps} />
        case 'button':
            return <IconButton {...iconProps} />
        case 'divider':
            return <IconDivider {...iconProps} />
        case 'spacer':
            return <IconSpacer {...iconProps} />
        case 'heading':
            return <IconHeading {...iconProps} />
        case 'youtube':
            return <IconYoutube {...iconProps} />
        case 'socialLinks':
            return <IconSocialLinks {...iconProps} />
        case 'countdown':
            return <IconCountdown {...iconProps} />
        case 'html':
            return <IconHtml {...iconProps} />
        case 'survey':
            return <IconSurvey {...iconProps} />
        case 'rss':
            return <IconRss {...iconProps} />
        case 'form':
            return <Form {...iconProps} />
        case 'lpNavMenu':
            return <IconLpNavMenu {...iconProps} />
    }

    console.error(`Unknown icon name: ${name}`)

    return null
}
